import { Injectable } from '@angular/core';
import { ApiHelper } from '../apiHelper';
import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import {Brand} from "../../models/brand";

@Injectable()
export class PaymentDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.PAYMENT, apiHelper);
  }

  public createStripeCustomer(data: any): Observable<any> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, data, headers, null);
  }

  public updatePaymentMethod(data: any): Observable<any> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/update-payment-method';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, data, headers, null);
  }

  public pauseSubscription(id:string): Observable<any> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/pause-sub';
    const headers = this.apiHelper.getDefaultHeader();
    const data = {
      subId: id,
    };
    return this.apiHelper.apiCall(url, 'POST', null, data, headers, null);
  }

  public reactivateSubscription(id:string): Observable<any> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/reactivate-sub';
    const headers = this.apiHelper.getDefaultHeader();
    const data = {
      subId: id,
    };
    return this.apiHelper.apiCall(url, 'POST', null, data, headers, null);
  }

}
